export default {
  id: 82,
  title: 'Target #82 - Diamond Cut',
  url: 'https://cssbattle.dev/play/82',
  colors: ['#F3AC3C', '#998235', '#1A4341'],
  solution:
    '<a><style>body{background:#f3ac3c}a{position:fixed;top:135;left:183;width:30;height:30;background:#1a4341;transform:rotate(45deg);box-shadow:0 -65px #f3ac3c,-65px 0 #f3ac3c,0 0 0 35px #f3ac3c,0 0 0 65px #998235}</style>',
}
